<div class="progress-cont" *ngIf="file?.progress != null && file?.progress < 100">
  <div class="progress" [style.width]="file?.progress + '%'">
  </div>
</div>
